import axios from "axios";
import store from "../../store/index";

function firstDefined() {
  for (var i = 0; i < arguments.length; i++) {
    var val = arguments[i];
    if (val !== undefined && val !== null) {
      return val;
    }
  }
  return undefined;
}

const emptyForm = () => ({
  organizationId: '',
  tenantName: '',
  tenantCode: '',
  url: '',
  authTenantId: '',
  connectionString: '',
  isActive: true,
  isDeleted: false,
  rootUserEmail: '',
  rootUserName: '',
  welcomeText: '',
  logoUrl: '',
  region: '',
  environment: '',
  licenseId: ''
});

const emptyErrors = () => ({
  organizationId: '',
  tenantName: '',
  tenantCode: '',
  rootUserEmail: ''
});

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: 'TenantModel',

  data() {
    return {
      baseUrl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      apiVersion: '',
      isShowModuleModal: false,
      isEditMode: false,
      isSubmitting: false,
      editingRecordId: '',
       formData: emptyForm(),
      errors: emptyErrors()
    };
  },

  computed:{
      headers(){
        return{
             'Content-Type': 'application/json',
             'Authorization': `Bearer ${this.idToken}`
             }
      }
  },

  methods: {
    openTenantModel(tenant) {
      this.resetForm();

      if (tenant) {
        this.isEditMode = true;
        this.editingRecordId = firstDefined(tenant.id, tenant.tenantId, '');
        this.formData = {
          organizationId: firstDefined(tenant.organizationId, ''),
          tenantName: firstDefined(tenant.tenantName, tenant.name, ''),
          tenantCode: firstDefined(tenant.tenantCode, tenant.code, ''),
          url: firstDefined(tenant.url, ''),
          authTenantId: firstDefined(tenant.authTenantId, ''),
          connectionString: firstDefined(tenant.connectionString, ''),
          isActive: firstDefined(tenant.isActive, true),
          isDeleted: firstDefined(tenant.isDeleted, false),
          rootUserEmail: firstDefined(tenant.rootUserEmail, ''),
          rootUserName: firstDefined(tenant.rootUserName, ''),
          welcomeText: firstDefined(tenant.welcomeText, ''),
          logoUrl: firstDefined(tenant.logoUrl, ''),
          region: firstDefined(tenant.region, ''),
          environment: firstDefined(tenant.environment, ''),
          licenseId: firstDefined(tenant.licenseId, '')
        };
      } else {
        this.isEditMode = false;
      }

      this.isShowModuleModal = true;
    },

    closeModuleModal() {
      this.isShowModuleModal = false;
      this.resetForm();
    },

    resetForm() {
      this.formData = emptyForm();
      this.editingRecordId = '';
      this.errors = emptyErrors();
    },

    validateField(fieldName) {
      const field = this.formData[fieldName];

      switch (fieldName) {
        case 'organizationId':
          this.errors.organizationId = (!field || String(field).trim().length === 0)
            ? 'Organization ID is required'
            : '';
          break;
        case 'tenantName':
          if (!field || String(field).trim().length === 0) {
            this.errors.tenantName = 'Tenant name is required';
          } else if (String(field).trim().length < 3) {
            this.errors.tenantName = 'Tenant name must be at least 3 characters';
          } else {
            this.errors.tenantName = '';
          }
          break;
        case 'tenantCode':
          this.errors.tenantCode = (!field || String(field).trim().length === 0)
            ? 'Tenant code is required'
            : '';
          break;
        case 'rootUserEmail':
          if (!field || String(field).trim().length === 0) {
            this.errors.rootUserEmail = 'Root user email is required';
          } else if (!EMAIL_REGEX.test(String(field).trim())) {
            this.errors.rootUserEmail = 'Enter a valid email address';
          } else {
            this.errors.rootUserEmail = '';
          }
          break;
      }
    },

    validateForm() {
      let isValid = true;

      ['organizationId', 'tenantName', 'tenantCode', 'rootUserEmail'].forEach(field => {
        this.validateField(field);
        if (this.errors[field]) {
          isValid = false;
        }
      });

      return isValid;
    },

    buildPayload() {
      const payload = { ...this.formData };

      if (this.isEditMode && this.editingRecordId) {
        payload.id = this.editingRecordId;
      }

      return payload;
    },

    buildQuery() {
      return this.apiVersion ? `?api-version=${encodeURIComponent(this.apiVersion)}` : '';
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      const payload = this.buildPayload();

      try {
        const response = this.isEditMode
          ? await axios.put(
              `${this.baseUrl}/admin/tenant/updatetenant/${encodeURIComponent(this.editingRecordId)}${this.buildQuery()}`,
              payload,
              {
                headers: this.headers
              }
            )
          : await axios.post(
              `${this.baseUrl}/admin/tenant/createtenant${this.buildQuery()}`,
              payload,
              {
                headers: this.headers
              }
            );

        this.$emit(this.isEditMode ? 'TenantModel-updated' : 'TenantModel-created', response.data);
        alert(this.isEditMode ? 'Tenant updated successfully' : 'Tenant created successfully');
        this.closeModuleModal();
      } catch (error) {
        const responseData = error.response && error.response.data;
        const message = (responseData && responseData.message) || error.message || 'Failed to save tenant';
        alert(`Error: ${message}`);
        console.error('Error saving tenant:', error);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};